// Omgevingen, eigen thema en agendaverbindingen (Arabisch). Zelfde vorm als omgevingApp.nl.ts.
export const appOmgevingAr = {
    spaces: {
        mine: 'مساحتي',
        switchLabel: 'تبديل المساحة',
        choose: 'اختر مساحة',
        private: 'خاصة',
        shared: 'مشتركة',
        dialogTitle: 'اختر مساحتك',
        dialogBody: 'خطّط لنفسك أو مع الآخرين.',
        close: 'إغلاق',
        current: 'المساحة الحالية',
        privateHint: 'خاصة · لك وحدك',
        sharedHint: 'مشتركة · نخطط معًا',
        opening: 'جارٍ فتح المساحة…',
        failed: 'لم ينجح التبديل. حاول مرة أخرى.',
        personalNotice: 'مساحتي · خاصة: هذا التخطيط وهذه البيانات لك وحدك. انتقل في الأعلى إلى المشتركة للتخطيط معًا.',
    },
    personalTheme: {
        title: 'مظهري',
        body: 'اختر شكل تطبيقك. يُحفظ هذا الاختيار في حسابك ويسري على جميع أجهزتك. تحتفظ اللوحة المشتركة والمستخدمون الآخرون بمظهرهم الخاص.',
        auto: 'اتبع مظهر أسرتي',
        warm: 'دافئ ومرح',
        calm: 'ناعم وهادئ',
        minimal: 'بسيط',
        graphic: 'أنيق وواضح',
        contrast: 'كبير وعالي التباين',
        failed: 'تعذّر تحميل مظهرك.',
        retry: 'حاول مرة أخرى',
        saved: 'تم حفظ مظهرك.',
    },
    calendarSync: {
        title: 'اتصالات التقويم الخاصة بي',
        intro: 'اربط تقويمك الأساسي في Google أو Microsoft بـ {name}. أنت وحدك تدير هذا الاتصال. داخل هذه المساحة تسري حقوق الوصول المعتادة على المواعيد المستوردة.',
        details: 'تلقائيًا كل خمس دقائق، من 30 يومًا مضت حتى سنة قادمة. تُزامَن المواعيد المتكررة كمواعيد منفصلة. يُتبادل العنوان والأوقات والمكان والملاحظات فقط، دون المشاركين أو الدعوات. عدّل الاجتماعات التي فيها مشاركون في Google أو Outlook.',
        connected: 'تم ربط التقويم. اختر زامن الآن للبدء فورًا.',
        failed: 'لم ينجح الربط أو تم إلغاؤه. حاول مرة أخرى.',
        retry: 'حاول مرة أخرى',
        provider: 'خدمة التقويم',
        google: 'تقويم Google / Gmail',
        googleShort: 'تقويم Google',
        microsoft: 'Microsoft 365 / Outlook',
        direction: 'اتجاه المزامنة',
        import: 'إلى AMUMIN فقط',
        export: 'من AMUMIN فقط',
        both: 'في الاتجاهين',
        scope: 'أي المواعيد تُرسل؟',
        scopeMine: 'المواعيد التي أشارك فيها',
        scopeAll: 'كل المواعيد في هذه المساحة',
        notConfigured: 'لا بد أن تفعّل AMUMIN خدمة التقويم هذه أولًا. تبقى اشتراكات التقويم الحالية متاحة.',
        alreadyConnected: 'متصل بالفعل',
        connect: 'ربط التقويم',
        lastSync: 'آخر مزامنة: {when}',
        neverSynced: 'لم تتم المزامنة بعد',
        conflicts: {
            zero: 'تم تغيير أو حذف {count} موعد في الجانبين. تم الاحتفاظ بها. راجع التقويمين واختر النسخة التي تريد الاحتفاظ بها.',
            one: 'تم تغيير أو حذف موعد واحد في الجانبين. تم الاحتفاظ به. راجع التقويمين واختر النسخة التي تريد الاحتفاظ بها.',
            two: 'تم تغيير أو حذف موعدين في الجانبين. تم الاحتفاظ بهما. راجع التقويمين واختر النسخة التي تريد الاحتفاظ بها.',
            few: 'تم تغيير أو حذف {count} مواعيد في الجانبين. تم الاحتفاظ بها. راجع التقويمين واختر النسخة التي تريد الاحتفاظ بها.',
            many: 'تم تغيير أو حذف {count} موعدًا في الجانبين. تم الاحتفاظ بها. راجع التقويمين واختر النسخة التي تريد الاحتفاظ بها.',
            other: 'تم تغيير أو حذف {count} موعد في الجانبين. تم الاحتفاظ بها. راجع التقويمين واختر النسخة التي تريد الاحتفاظ بها.',
        },
        synced: 'تمت المزامنة.',
        syncNow: 'زامن الآن',
        keepLocal: 'احتفظ بنسخ AMUMIN',
        keepRemote: 'احتفظ بالنسخ الخارجية',
        disconnect: 'إيقاف الاتصال',
        disconnectHint: 'الإيقاف لا يحذف أي موعد. لتغيير الاتجاه، أوقف الاتصال ثم اربط من جديد.',
        personalLinks: 'يبقى تقويمك الشخصي خاصًا. تنشئ روابط الاشتراك المشتركة من مساحتك المشتركة.',
    },
    errors: {
        personalSpacePrivate: 'مساحتك الشخصية لك وحدك. انتقل إلى المشتركة لدعوة أشخاص أو ربط لوحة.',
        providerNotConfigured: 'لم تفعّل AMUMIN خدمة التقويم هذه بعد.',
        alreadyConnected: 'خدمة التقويم هذه متصلة بالفعل. أوقف الاتصال الحالي أولًا لتربط من جديد.',
    },
    rideOpen: {
        dropoff: 'من يوصل {names} إلى {title}؟',
        dropoffNoNames: 'من يوصل إلى {title}؟',
        pickup: 'من يحضر {names} من {title}؟',
        pickupNoNames: 'من يحضر من {title}؟',
    },
    notMeHint: '{link}: استخدم الرابط في أسفل الرسالة.',
    ingredientsPlaceholder: '500 غ لحم مفروم\n1 بصلة\n1 علبة طماطم',
};
//# sourceMappingURL=omgevingApp.ar.js.map